import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, SearchBar } from 'web-library';


import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  searchContainer: {
    paddingBottom: theme.spacing(2),
  },
}));

export interface CandidateSearchProps {
  /** to handle search function to fetch the data
   * */
  onSearch: (value: string) => void;
  clearErrors: () => void;
  loading: boolean;
}

const CandidateSearch: React.FC<CandidateSearchProps> = (props: CandidateSearchProps) => {
  const { onSearch = () => null, clearErrors, loading } = props;
  const [isTextEmpty, setIsTextEmpty] = useState<boolean>(false);
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Box className={classes.searchContainer}>
      <SearchBar
        name="searchInput"
        ariaLabel="searchInput"
        defaultValue=""
        placeholder={t('resit->>OpAdminResit.Search by NRIC/FIN/Passport No.')}
        helperText={isTextEmpty ? 'Please enter NRIC/FIN/Passport No.' : ''}
        onSearch={(str) => {
          if (loading) {
            return;
          }
          if (str === '' || str.trim() === '') {
            setIsTextEmpty(true);
            clearErrors();
            return;
          }
          setIsTextEmpty(false);
          onSearch(str);
        }}
        error={isTextEmpty}
      />
    </Box>
  );
};
export default CandidateSearch;
